/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint-disable */
const state = {
  homeRc2Nav: {
    route: null,
    page_name: null,
    sections: [],
  },
  rc2Navigation :{
    navs:[{
        page_name:'hodwelling',
        sections:['Dwelling Details','Property Features'] 
        },
        {
        page_name:'hocoverage',
        sections:['Coverage Details','Sports Equipment','Stamps','Bicycle','Fine Arts','Coins','Musical Instrument','Scheduled Personal Property','Jewelry','Bicycle','Camera','Firearms','Computer','Golf','Boat Dock Lifts','Silverware','Fur']
        },
        {
        page_name:'homortgage',
        sections:['Primary Mortgage','Mortgage Two','Mortgage Three']
        },
       {
        page_name:'hopolicydetails',
        sections:['Branch Quote Update | Confirm the following with the customer:', 'Reporting Consent ', 'Missing Driver\'s License Number']
        },
        {
         page_name:'hocheckout',
         sections:[]
         },
         {
          page_name:'hoconfirmation',
          sections:[]
          }
      ]
 }
 };

const getters = {
  homeRc2Nav(state) {
     return state.homeRc2Nav;
  },
  rc2Navigation(state){
    return state.rc2Navigation;  
  }
};

const mutations = {
  updatehomeRc2Nav(state, homeRc2Navpagename) {
    let filterProgData =  state.rc2Navigation.navs.filter(el => el.page_name == homeRc2Navpagename);
     state.homeRc2Nav = filterProgData[0];
  },
};

const actions = {
  sethomeRc2Nav({ commit }, homeRc2Nav) {
    commit('updatehomeRc2Nav', homeRc2Nav);
  },
};

/**
 * export module to main store.js
 */
export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/homeNav.js